import styled from 'styled-components/macro';

export const MainContainer = styled.div`
  height: 100%;
  display: flex;
  width: 100%;

  @media (max-width: 800px) {
    display: block;
  }
`;
